import axios from "axios";

const isDev =false;

const axiosInstance = axios.create({
  baseURL: isDev
    ? "http://localhost/realmart_api/public"
    : "https://realmart.jemins.in/api/public",
  timeout: 100000,
});

let reduxStore; // 🔹 injected later

export const injectStore = (store) => {
  reduxStore = store;
};

axiosInstance.interceptors.request.use(
  (config) => {
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // ✅ Token expired / invalid
      localStorage.removeItem("token");

      // ✅ Logout Redux user
      if (reduxStore) {
        reduxStore.dispatch({ type: "user/logoutUser" });
      }

      // ✅ Redirect to login
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;

